/** @jsxImportSource @emotion/react */
import React, { useState } from 'react';

import ExternalLink from '../ExternalLink';
import {
  closeButton,
  videoContainer,
  videoOverlay,
  videoWrapper,
} from '../FAProgrammes/styles';
import Link from '../Link';
import Text from '../Text';
import useStyles from './styles';

const ClubVsCasual = ({
  heading,
  description,
  images,
  indexVal,
  ctaId,
  videos,
  buttonText,
  href,
}) => {
  const styles = useStyles();
  const [showVideo, setShowVideo] = useState(false);
  const [cardHovered, setCardHovered] = useState(false);
  const hasVideo = Boolean(videos)

  const disableScrolling = () => {
    document.documentElement.style.overflow = 'hidden';
  };

  const enableScrolling = () => {
    document.documentElement.style.overflow = '';
  };

  const handleClick = () => {
    if (!hasVideo) return;

    setShowVideo(true);
    disableScrolling();
  };

  const handleCloseVideo = e => {
    e.stopPropagation();
    setShowVideo(false);
    enableScrolling();
  };

  const handleKeyDown = (e, action) => {
    switch (e.key) {
      case 'Enter':
        if (e.key === 'Enter') {
          e.preventDefault();
        }
        if (action === 'open') {
          handleClick();
        } else if (action === 'close') {
          handleCloseVideo(e);
        }
        break;

      default:
        break;
    }
  };

  return (
    <div css={styles.clubVsCasualContainer}>
      <div css={styles.clubcards} id={ctaId}>
        <div css={styles.innerWrapper}>
          <div css={styles.card}>
            <Link
              css={styles.imgSection(images, indexVal, hasVideo)}
              tabIndex={0}
              onClick={handleClick}
              onKeyDown={e => handleKeyDown(e, 'open')}
            >
              {hasVideo && showVideo && (
                <div
                  css={videoOverlay}
                  onClick={handleCloseVideo}
                  onKeyDown={e => handleKeyDown(e, 'close')}
                  tabIndex={0}
                  role="button"
                >
                  <div
                    css={videoContainer}
                    onClick={e => e.stopPropagation()}
                    onKeyDown={e => e.stopPropagation()}
                    role="button"
                  >
                    <div css={videoWrapper}>
                      <iframe
                        width="100%"
                        height="100%"
                        src={videos}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        title="video"
                      ></iframe>
                      <img
                        css={closeButton}
                        src="/images/desktop/home/closeLightboxVideo.svg"
                        alt="Close Video"
                        onClick={handleCloseVideo}
                        onKeyDown={e => handleKeyDown(e, 'close')}
                        tabIndex={1}
                      />
                    </div>
                  </div>
                </div>
              )}
              {!showVideo && (
                <div css={styles.imageWrapper}>
                  {
                    hasVideo && (
                      <img
                        src="/images/desktop/home/videoPlay.svg"
                        alt="Play Video"
                        onClick={handleClick}
                        className="youtube"
                        onKeyDown={e => handleKeyDown(e, 'open')}
                      />
                    )
                  }
                </div>
              )}
            </Link>

            <div css={styles.infoSection}>
              <div css={styles.cardalign}>
                <Text
                  as="p"
                  css={styles.header(hasVideo)}
                  onClick={handleClick}
                  onKeyDown={e => handleKeyDown(e, 'open')}
                >
                  {heading}
                </Text>
                <Text
                  css={styles.description(hasVideo)}
                  onClick={handleClick}
                  onKeyDown={e => handleKeyDown(e, 'open')}
                >
                  {/* {description.substring(0, CHARLIMIT_TEAMVSCASUAL)} */}
                  {description}
                </Text>
                <ExternalLink
                  css={styles.link}
                  href={href}
                  onMouseEnter={() => setCardHovered(true)}
                  onMouseLeave={() => setCardHovered(false)}
                >
                  <Text css={styles.learnMore}>
                    <span css={styles.learnmore}>{buttonText}</span>
                    <img
                      css={styles.learnmoreArrow}
                      src={
                        cardHovered
                          ? '/images/desktop/home/rightArrowWhite.svg'
                          : '/images/desktop/home/rightArrow.svg'
                      }
                      alt="/images/desktop/home/rightArrow.svg"
                    />
                  </Text>
                </ExternalLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClubVsCasual;
